import React from 'react';
import { StarIcon } from 'lucide-react';
import { TESTIMONIOS } from '../../data/content';
export function Testimonials() {
  return <section className="bg-crema py-16 sm:py-20 px-5" data-id="element-267" data-mp="3hi8uxv4glbc9">
      <div className="max-w-6xl mx-auto" data-id="element-268" data-mp="3mgaf6jdmfgpb">
        <h2 className="font-serif text-3xl sm:text-4xl font-bold text-violeta text-center leading-tight" data-id="element-269" data-mp="3mf7r0j7onsd3">
          Lo que cuentan otras familias
        </h2>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-270" data-mp="1r1kowh05jw">
          {TESTIMONIOS.map(t => <figure key={t.nombre} className="rounded-2xl bg-white border border-black/5 shadow-sm p-6 flex flex-col" data-id="element-271" data-mp="421fcnqi809b">
              <div className="flex" aria-label="5 de 5 estrellas" data-id="element-272" data-mp="e0z2pnc71nqq">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="w-4 h-4 text-dorado fill-dorado" aria-hidden="true" data-id="element-273" data-mp="2au2a3v4ysiy0" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-base sm:text-lg italic text-tinta/85 leading-snug flex-1" data-id="element-274" data-mp="2fsly0134c4t0">
                “{t.texto}”
              </blockquote>
              <figcaption className="mt-5" data-id="element-275" data-mp="1ntkjx1hm3hcf">
                <span className="block font-bold text-violeta" data-id="element-276" data-mp="1nshruq8jz8ux">{t.nombre}</span>
                <span className="block text-sm text-tinta/60" data-id="element-277" data-mp="1ivizod8g9bzd">{t.ciudad}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}